import * as types from '../mutation_types';

export default {
  [types.SET_PARKING_LOT](state, value) {
    state.parking_lot = value;
  }
}
